import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BackToSearchService {

  public backToSearchShared: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public backToSearchChildShared: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor() { }

  getBackToSearchSharedData(): Observable<any> {
    return this.backToSearchShared.asObservable();
  }

  setBackToSearchSharedData(data: any) {
    this.backToSearchShared.next(data);
  }

  getBackToSearchChildSharedData(): Observable<any> {
    return this.backToSearchChildShared.asObservable();
  }

  setBackToSearchChildSharedData(data: any) {
    this.backToSearchChildShared.next(data);
  }
}
